import { Controller } from '@hotwired/stimulus'
import { fetchTurbo } from '../utils/fetch-turbo'

// Кнопка «More» под блоком матчей (account/matches/_more_button.slim):
// запрашивает следующую порцию и применяет turbo_stream-ответ сам — ссылка с
// data-turbo-stream не годится: на <body> Turbo выключен, и она ушла бы
// обычным переходом. Ответ дописывает карточки и заменяет кнопку
// (Account::MatchesController#more) — тот же приём, что в tournament_score.
export default class LoadMoreController extends Controller {
  static values = { url: String }

  async load(event) {
    event.preventDefault()
    if (this.loading) return

    this.loading = true
    this.element.setAttribute('aria-busy', 'true')
    try {
      const response = await fetchTurbo(this.urlValue, { method: 'GET' })
      if (!response.ok) throw new Error(`load more failed: ${response.status}`)

      window.Turbo?.renderStreamMessage(await response.text())
    } catch {
      // Сеть или сервер подвели — кнопка остаётся, можно нажать ещё раз.
    } finally {
      this.loading = false
      this.element.removeAttribute('aria-busy')
    }
  }
}
